import Group from 'components/utils/Group'
import { useMemo } from 'react'
import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import { getAgentHubExperienceType } from 'lib/agentHub/agentHubUtils'
import ExperienceTilePrices from 'components/Experiences/ExperienceTiles/ExperienceTilePrices'
import { ViewOfferButton } from './ViewOfferButton'

interface Props {
  experience: App.ExperienceBookingView
  variant?: 'default' | 'condensed'
}

function ExperienceOfferPriceDetails(props: Props) {
  const { experience, variant = 'default' } = props
  const productType = useMemo(() => getAgentHubExperienceType(experience.originalExperience), [experience])
  const { pricing, location } = experience

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
      <Group direction="vertical" verticalAlign="end">
        <ExperienceTilePrices
          isFromPrice
          totalPrice={pricing.price}
          totalMemberPrice={pricing.memberPrice}
          totalGrossPrice={pricing.value}
          discountPercentage={pricing.discountPercent}
          ticketUnitLabel={pricing.saleUnit}
          size="L"
          nonMemberPriceSize="L"
        />
        <PriceRowAgentHubCommission
          offer={experience.originalExperience}
          offerId={experience.id}
          productType={productType}
          offerLocations={location ? [location] : undefined}
        />
      </Group>
      <ViewOfferButton variant={variant} />
    </Group>
  )
}

export default ExperienceOfferPriceDetails
